export const API_URL = 'https://api.palipali.pl';
